import Vue from 'vue'

class ErrorTrackingService {
  static setUser(user: any) {
    try {
      const userData = {
        id: user?.id,
        name: user?.name,
        email: user?.email,
        businessType: user?.businessType?.slug ?? 'unset',
        verified: !!user?.verified,
        items_count: user?.items_count,
        phone: user?.phone,
        restaurant_name: user?.restaurant_name,
      }

      // @ts-ignore
      if (Vue.$honeybadger) {
        // @ts-ignore
        Vue.$honeybadger.setContext(userData)
      }
    } catch (error) {
      console.error('Set honeybadger user failed', error)
    }
  }
}

export default ErrorTrackingService
